import Component from '../../../shared/component';

export default class AchievementOnboardingActionButton extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.bindEvents();
  }

  bindEvents() {
    this.handleClick = this.handleClick.bind(this);

    this.$element.on(
      'click.AchievementOnboardingOutgoingAction',
      this.handleClick
    );
  }

  unbindEvents() {
    this.$element.off(
      'click.AchievementOnboardingOutgoingAction',
      this.handleClick
    );
  }

  handleClick() {
    $.ajax({
      url: this.$element.data('achievement-dispatching-path'),
      // eslint-disable-next-line camelcase
      data: {achievement_id: this.$element.data('achievement-id')},
      method: 'POST',
    });
  }
}
